import React from "react";
import "./ScopeDescription.css"; // Make sure to create this CSS file

function ScopeDescription({ scopeDescription }) {
  return (
    <div
      className="scope-description-container"
      style={{ marginTop: "20px" }}
    >
      <div className="scope-description-header">
        <h2 className="scope-description-title">Scope Description</h2>
      </div>
      <div className="scope-description-content">
        <div className="scope-description-text">
          {scopeDescription || '-'}
        </div>
      </div>
    </div>
  );
}

export default ScopeDescription;